/**
 * Global Configuration Constants
 *
 * This file contains easily configurable values used throughout the application.
 * Update these values to reflect current settings without searching through components.
 */

// Google Apps Script URL for forms and data
export const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwb7hvlgj3F_bNWh8DSrvkwKAFLrN-qeq-k86BDy4IElw5jgNhYekZA1RE7uVAjb_QB/exec";

// Event Configuration - mutable for dynamic updates
export const EVENT_CONFIG = {
  /**
   * Number of remaining seats available for registration
   * Update this number as registrations come in
   */
  REMAINING_SEATS: 0,

  /**
   * Total number of seats available
   * This is used to calculate percentage filled, etc.
   */
  TOTAL_SEATS: 45,

  /**
   * Event dates
   */
  START_DATE: "2025-07-18",
  END_DATE: "2025-07-20",

  /**
   * Registration deadline
   */
  REGISTRATION_DEADLINE: "2025-07-15",
};

// UI Configuration
export const UI_CONFIG = {
  /**
   * Show urgency messages when seats are below this threshold
   */
  URGENCY_THRESHOLD: 25,

  /**
   * Color scheme for seat availability
   */
  SEAT_COLORS: {
    MANY_AVAILABLE: "#97d700", // Green - many seats left
    FEW_AVAILABLE: "#ff8c00",  // Orange - few seats left
    VERY_FEW: "#ff4444",       // Red - very few seats left
  }
} as const;

// Derived values (calculated automatically)
export const getDerivedValues = () => {
  const remainingSeats = EVENT_CONFIG.REMAINING_SEATS;
  const totalSeats = EVENT_CONFIG.TOTAL_SEATS;

  return {
    /**
     * Percentage of seats filled
     */
    percentageFilled: Math.round(((totalSeats - remainingSeats) / totalSeats) * 100),

    /**
     * Whether to show urgency messaging
     */
    showUrgency: remainingSeats <= UI_CONFIG.URGENCY_THRESHOLD,

    /**
     * Color to use for seat display based on availability
     */
    seatColor: remainingSeats <= 2
      ? UI_CONFIG.SEAT_COLORS.VERY_FEW
      : remainingSeats <= UI_CONFIG.URGENCY_THRESHOLD
        ? UI_CONFIG.SEAT_COLORS.FEW_AVAILABLE
        : UI_CONFIG.SEAT_COLORS.MANY_AVAILABLE,

    /**
     * Formatted remaining seats text
     */
    remainingSeatsText: `${remainingSeats} plazas restantes`,

    /**
     * Urgency message based on remaining seats
     */
    urgencyMessage: remainingSeats <= 2
      ? "¡Últimas plazas disponibles!"
      : remainingSeats <= UI_CONFIG.URGENCY_THRESHOLD
        ? "¡Pocas plazas disponibles!"
        : "Plazas disponibles"
  };
};
